import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {
    IWastyIntermediary
} from "../../../../../../utils/interfaces/special_wasty/wasty_intermediary/IWastyIntermediary";


const useApiGetWastyIntermediary = (pk: number | undefined): UseQueryResult<IWastyIntermediary, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IWastyIntermediary> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/special_wasty/wasty_intermediary/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetWastyIntermediary", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk,
    })

};

export default useApiGetWastyIntermediary